import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "reactstrap";
import {
  useGetCrmBankingDocumentsByIdQuery,
  useUploadMediaFarmerMutation,
} from "features/onboarding/users/farmer/farmerApiSlice";
import Lightbox from "react-awesome-lightbox";
import { Spinner, Table } from "react-bootstrap";
import "react-awesome-lightbox/build/style.css";
import { store } from "app/store";
import axios from "axios";
import { API_URL } from "app/config";
import { toast } from "react-toastify";
import swal from "sweetalert";
import { useUpdateCrmLeadByIdMutation } from "features/banking/BankingApiSlice";
import { CattleDetailViewTable } from "./CattleDetailViewTable";
import { TextField, Typography } from "@mui/material";
import { useUploadInsuranceFarmerDocsMutation } from "features/Insurance/InsuranceApiSlice";

export const ClaimDetailView = ({
  LeadsDataHalf,
  refetchLeadsData,
  refetch,
}) => {
  const [openLightbox, setOpenLightBox] = useState(false);
  const [lightBoxViewImage, setImageInLightbox] = useState("");
  const [mediaType, setMediaType] = useState("");
  const [overlayUrl, setOverlayUrl] = useState("");
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [uploadMedia] = useUploadMediaFarmerMutation();
  const [updateCrmLead] = useUpdateCrmLeadByIdMutation();
  const [multipleDownloadFarmers] = useUploadInsuranceFarmerDocsMutation();

  const [zipDownload, setZipDownload] = useState(false);

  const id = LeadsDataHalf?.user_id;
  const {
    data: documents,
    refetch: refetchDocuments,
  } = useGetCrmBankingDocumentsByIdQuery(id, {
    skip: !id,
    refetchOnMountOrArgChange: true,

  });
  const [remarks, setRemarks] = useState("");
  const [paymentDetails, setPaymentDetails] = useState({
    paymentId: "",
    amount: "",
    remark: "",
    receiptFile: null,
  });
  const [claimRequestLoading, setClaimRequest] = useState(false);
  const [paymentUploading, setpaymentUploading] = useState(false);
  const [IncidentDetails, setIncidentDetails] = useState([]);
  const [claimType, setClaimType] = useState("");
  const [cattleEntityId, setCattleEntityId] = useState("");
    const [PaymentSettlement, setPaymentSettlement] = useState([]);

  useEffect(() => {
    if (!documents || !LeadsDataHalf) return;
    const cattle =
      LeadsDataHalf?.lead_details?.[0]?.service_details?.incident_details;
    const cattleEntityId = `${cattle?.cattle_tag_number}_${cattle?.cattle_id}`;
    const docTypes = [
      { key: "incidentPhotos", type: "Incident Photos" },
      { key: "tagPhotos", type: "Cattle Tag Photo" },
      { key: "earTagVideos", type: "Ear Tag Cutting Video" },
      { key: "completedClaimForms", type: "Completed Claim Form" },
      { key: "animalHealth", type: "Animal Health Certificate" },
      { key: "vetDeathCert", type: "Veterinary Death Certificate" },
      { key: "postMortem", type: "Post Mortem Report" },
      { key: "Policy", type: "Policy" },
      { key: "otherDocuments", type: "Other Documents" },
    ];


    const category = documents?.data?.find(
      (c) => c.document_category === "Cattle Claim Documents"
    );

    if (!category) return;
    const result = {};
    docTypes.forEach(({ key, type }) => {
      const docs =
        category.document_types?.find((t) => t.document_type === type)
          ?.documents || [];
      result[key] = docs.filter(
        (doc) => doc.entity_id?.toLowerCase() === cattleEntityId?.toLowerCase()
      );
    });
     const settlementDocs =
    category.document_types?.find(
      (t) => t.document_type === "Claim Settlement Proof"
    )?.documents || [];

  const filteredSettlementDocs = settlementDocs?.filter(
    (doc) =>
      doc.entity_id?.toLowerCase() === cattleEntityId.toLowerCase()
  );
    setPaymentSettlement(filteredSettlementDocs)
    setIncidentDetails(result);
    setCattleEntityId(cattleEntityId);
  }, [documents, LeadsDataHalf]);
 

  // console.log("Leadsdata", LeadsDataHalf);
  const refetchPreAssigned = async (path, type) => {
    const state = store.getState();
    try {
      const pathImageCattle = await axios.get(
        `${API_URL}/api/v1/onboarding/media/get_file?path=${path}`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!pathImageCattle?.data?.data?.url) return;
      const url = pathImageCattle?.data?.data?.url;
      if (type === "image") {
        setImageInLightbox(url);
        setOpenLightBox(true);
      } else if (type === "pdf") {
        openInNewTab(url);
      } else if (type === "mp4") {
        setOverlayUrl(url);
        setOverlayOpen(true);
      }
    } catch (error) {
      console.error("Error fetching farmer data:", error);
      throw error;
    }
  };
  // const refetchPreAssignedPolicy = async (path, type) => {
  //   const state = store.getState();
  //   try {
  //     const pathImagePolicy = await axios.get(
  //       `${API_URL}/api/v1/crm/leads/media/get_file?path=${path}`,

  //       {
  //         headers: {
  //           Authorization: `Bearer ${state.auth.accessToken}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     if (!pathImagePolicy?.data?.data?.url) return;
  //     const url = pathImagePolicy.data.data?.url;
  //     if (type === "image") {
  //       setImageInLightbox(url);
  //       setOpenLightBox(true);
  //     } else if (type === "pdf") {
  //       setOpenLightBox(false);
  //       openInNewTab(url);
  //     } else if (type === "mp4") {
  //       setOverlayUrl(url);
  //       setOverlayOpen(true);
  //       setOpenLightBox(false);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching farmer data:", error);
  //     throw error;
  //   }
  // };

  const convertToTitleCase = (text) => {
    if (!text) return "";
    return String(text)
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0)?.toUpperCase() + word.slice(1))
      .join(" ");
  };

  const getTypeFromPath = (p) => {
    if (!p) return "image";
    const lower = p.toLowerCase();
    if (lower.endsWith(".pdf")) return "pdf";
    if (lower.endsWith(".mp4")) return "mp4";
    if (/\.(jpg|jpeg|png|gif|webp|bmp)$/i.test(lower)) return "image";
    return "image";
  };
  const handleZipDownload = () => {
    setZipDownload(true);
    const leadIdArray = [LeadsDataHalf.user_id];
    const responseData = {
      farmer_id_list: leadIdArray,
      zip_file_name: "Documents",
      entity_id_list:[cattleEntityId?.toUpperCase()],
      categories: ["cattle claim documents", "kyc documents", "bank documents"],
    };
    multipleDownloadFarmers(responseData)
      .unwrap()
      .then((data) => {
        if (data?.data) {
          toast.success("Downloaded Successfully !!");
          window.open(data?.data, "_blank", "noopener,noreferrer");
          setZipDownload(false);
        }
      })
      .catch((error) => {
        toast.error("Error while Creating Task");
        setZipDownload(false);

        return;
      });
  };

  const openInNewTab = async (URL) => {
    const res = await fetch(URL);
    const uint8arr = new Uint8Array(await new Response(res.body).arrayBuffer());

    const link = document.createElement("a");
    const blob = new Blob([uint8arr], { type: "application/pdf" });

    link.target = "_blank";
    link.href = window.URL.createObjectURL(blob);
    link.click();
  };

  const handleDocClick = (doc) => {
    if (!doc?.path) return;
    const type = getTypeFromPath(doc.path);
    setMediaType(type);
    refetchPreAssigned(doc.path, type);
  };

  const submitClaim = (type) => {
    if (remarks === "") {
      swal("Please Enter Remarks.", {
        buttons: false,
        icon: "warning",
        title: "Missing Fields",
        timer: 1500,
      });
      return;
    }
    setClaimRequest(true);
    setClaimType(type);
    let sendPayload = {
      current_remarks: remarks,
      current_status: type,
    };
    updateCrmLead({ id: LeadsDataHalf.id, payload: sendPayload })
      .unwrap()
      .then(() => {
        toast.success("Updated Successfully!");
        setPaymentLoading(false);
        setClaimRequest(false);
        refetchLeadsData(LeadsDataHalf.id);
        refetch();
      })
      .catch(() => {
        toast.error("Error while Updating Leads. Try again later!");
        setPaymentLoading(false);
        setClaimRequest(false);
      });
  };

  const handlePaymentChange = (field, value) => {
    setPaymentDetails((prev) => ({ ...prev, [field]: value }));
  };

  const handlePaymentFile = (file) => {
    setPaymentDetails((prev) => ({ ...prev, receiptFile: file }));
  };
  const handlePaymentSubmit = async () => {
    if (
      !paymentDetails.receiptFile ||
      !paymentDetails.remark?.trim() ||
      !paymentDetails.amount ||
      !paymentDetails.paymentId?.trim()
    ) {
      swal("Please fill all required details.", {
        buttons: false,
        icon: "warning",
        title: "Missing Fields",
        timer: 1500,
      });
      return;
    }

    setpaymentUploading(true);

    const formData = new FormData();
    formData.append("media_type", "Claim Settlement Proof");
    formData.append("media_category", "Cattle Claim Documents");
    // formData.append("entity_id", LeadsDataHalf?.id);
    formData.append("entity_id", cattleEntityId?.toUpperCase());
    formData.append("file_type", "Claim Settlement Proof");
    formData.append("filename", "Claim Settlement Proof");
    formData.append("files", paymentDetails.receiptFile);
    formData.append("remark", paymentDetails.remark);
    formData.append("amount", paymentDetails.amount);
    formData.append("payment_id", paymentDetails.paymentId);

    try {
      const mediaResponse = await uploadMedia({
        id: LeadsDataHalf.user_id,
        formData,
      }).unwrap();

      const sendPayload = {
        current_status: "Claim Settled",
        current_remarks: paymentDetails.remark,

        lead_details:
          LeadsDataHalf?.lead_details?.map((l) => {
            return {
              ...l,
              service_details: {
                ...l.service_details,
                incident_details: {
                  ...l.service_details.incident_details,
                },
                payment_details: {
                  amount: paymentDetails.amount || "",
                  remark: paymentDetails.remark || "",
                  payment_id: paymentDetails.paymentId || "",
                },
              },
            };
          }) || [],
      };
      await updateCrmLead({
        id: LeadsDataHalf.id,
        payload: sendPayload,
      }).unwrap();
      toast.success("Payment document uploaded successfully!");
      setPaymentDetails({});
      refetchDocuments();
      refetchLeadsData(LeadsDataHalf.id);
      refetch();
      setpaymentUploading(false);
    } catch (err) {
      console.error("Error while uploading payment:", err);
    } finally {
      setpaymentUploading(false);
    }
  };
  const EXCLUDED_KEYS = ["otherDocuments"];

  const hasAnyDocument = Object.entries(IncidentDetails || {})
    .filter(([key]) => !EXCLUDED_KEYS.includes(key))
    .every(([_, arr]) => Array.isArray(arr) && arr.length > 0);

  // const hasAnyDocument = Object.values(IncidentDetails || {}).every(
  //   (arr) => arr?.length > 0
  // );

  const formatDateTime = (dateString) => {
    if (!dateString) return "";

    let date;

    if (dateString.includes("T")) {
      date = new Date(dateString);
    } else {
      const [datePart, timePart] = dateString.split(" ");
      const parts = datePart?.split("/");

      if (parts?.length === 3) {
        const [day, month, year] = parts;

        const time = timePart ? `${timePart}:00` : "00:00:00";

        date = new Date(`${year}-${month}-${day}T${time}`);
      }
    }

    if (!date || isNaN(date.getTime())) return "";

    const day = date.getDate();
    const month = date.toLocaleString("en-IN", { month: "long" });
    const year = date.getFullYear();

    const time = date
      .toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(" ", "")
      .toUpperCase();

    return `${day} ${month} ${year} , ${time}`;
  };

  // console.log("hasAnyDocument", hasAnyDocument);
  const renderPhotos = (doc) => {
    return (
      <div
        key={doc.id}
        className="text-center"
        style={{
          width: 120,
          cursor: "pointer",
          flexShrink: 0,
        }}
        onClick={() => {
          handleDocClick(doc);
        }}
      >
        <div
          style={{
            border: "1px solid #ddd",
            borderRadius: 6,
            padding: 4,
            background: "#fff",
            transition: "all 0.2s ease-in-out",
          }}
          className="hover-shadow"
        >
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSITKmWTrarr0VI2iJrXYZBRO0rA9IE8Tj7jg&s"
            alt={convertToTitleCase(doc?.media_type)}
            width="100"
            height="60"
            style={{
              objectFit: "cover",
              borderRadius: 4,
              display: "block",
              margin: "0 auto",
            }}
          />
        </div>

        <div
          style={{
            fontSize: 13,
            fontWeight: 500,
            color: "#444",
            textAlign: "center",
            wordBreak: "break-word",
          }}
          title={convertToTitleCase(doc?.media_type)}
          className="mt-2"
        >
          {convertToTitleCase(doc?.media_type)}
        </div>
      </div>
    );
  };
  const hasBankDocs = documents?.data?.some(
    (category) =>
      category?.document_category?.toLowerCase() === "bank documents" &&
      category?.document_types?.some((docType) =>
        docType?.documents?.some(
          (doc) =>
            doc.entity_id?.toLowerCase() === cattleEntityId?.toLowerCase()
        )
      )
  );

  const hasKycDocs = documents?.data?.some(
    (category) =>
      category?.document_category?.toLowerCase() === "kyc documents" &&
      category?.document_types?.some(
        (docType) => docType?.documents?.length > 0
      )
  );
  const hasOtherDocsExceptIncident = Object.entries(IncidentDetails || {})
    .filter(([key]) => key !== "incidentPhotos" && key !== "otherDocuments")
    .some(([, value]) => Array.isArray(value) && value.length > 0);
  const hasOtherDocuments =
    Array.isArray(IncidentDetails?.otherDocuments) &&
    IncidentDetails.otherDocuments.length > 0;

  return (
    <>
      <Row>
        <Col md={12} lg={12}>
          <div
            style={{
              borderRadius: 10,
              padding: 24,
              boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
              marginBottom: 24,
              backgroundColor: "white",
              border: "1px solid #f0f0f0",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingBottom: 10,
              }}
            >
              <h6 style={{ fontWeight: 600, margin: 0 }}>APPLICANT DETAILS</h6>
              <button
                style={{
                  background: "linear-gradient(135deg, #2980b9, #3498db)",
                  color: "white",
                  border: "none",
                  padding: "6px 10px",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: 600,
                  cursor: "pointer",
                  transition: "0.3s",
                  marginLeft: "8px",
                  marginRight: "8px",
                }}
                onClick={() => handleZipDownload()}
                onMouseOver={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 4px 10px rgba(41, 128, 185, 0.4)")
                }
                onMouseOut={(e) => (e.currentTarget.style.boxShadow = "none")}
              >
                Download Documents {zipDownload && <Spinner size="sm" />}
              </button>
            </div>

            <div className="d-lg-block d-md-block d-none mt-3 mb-3">
              <CattleDetailViewTable LeadsDataHalf={LeadsDataHalf} />
            </div>
          </div>
        </Col>
        <Col md={12} lg={12}>
          <div
            style={{
              borderRadius: 10,
              padding: 24,
              boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
              marginBottom: 24,
              backgroundColor: "white",
              border: "1px solid #f0f0f0",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingBottom: 10,
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <h6 style={{ fontWeight: 600, margin: 0 }}>INCIDENT DETAILS</h6>
              </div>
            </div>

            <div className="mt-3 mb-3">
              <Table className="table mb-2" hover>
                <tbody>
                  {[
                    {
                      label: "Cattle ID",
                      value:
                        LeadsDataHalf?.lead_details?.[0]?.service_details
                          ?.incident_details?.cattle_id,
                    },
                    {
                      label: "Tag Number",
                      value:
                        LeadsDataHalf?.lead_details?.[0]?.service_details
                          ?.incident_details?.cattle_tag_number,
                    },
                    {
                      label: "Incident Occurance Date",
                      value: formatDateTime(
                        LeadsDataHalf?.lead_details?.[0]?.service_details
                          ?.incident_details?.incident_date_time
                      ),
                    },
                    {
                      label: "Incident Reporting Date",
                      value: formatDateTime(LeadsDataHalf?.created_at),
                    },
                    {
                      label: "Cattle Type",
                      value:
                        LeadsDataHalf?.lead_details?.[0]?.service_details
                          ?.incident_details?.cattle_type,
                    },
                    {
                      label: "Location",
                      value:
                        LeadsDataHalf?.lead_details?.[0]?.service_details
                          ?.incident_details?.incident_location,
                    },
                    {
                      label: "Cause of Loss",
                      value:
                        LeadsDataHalf?.lead_details?.[0]?.service_details
                          ?.incident_details?.cause_of_loss,
                      isDanger: true,
                    },
                    {
                      label: "Description",
                      value:
                        LeadsDataHalf?.lead_details?.[0]?.service_details
                          ?.incident_details?.incident_description,
                      isLongText: true,
                    },
                  ]
                    .reduce((rows, item, i, arr) => {
                      if (i % 2 === 0)
                        rows.push([
                          item,
                          arr[i + 1] || { label: "", value: "" },
                        ]);
                      return rows;
                    }, [])
                    .map((row, rIdx) => (
                      <tr key={rIdx}>
                        {row.map((cell, cIdx) => (
                          <React.Fragment key={cIdx}>
                            <th
                              scope="row"
                              className="align-middle"
                              style={{ width: "20%" }}
                            >
                              {cell.label ? `${cell.label}:` : ""}
                            </th>

                            <td
                              className="align-middle"
                              style={{
                                width: "30%",
                                whiteSpace: cell.isLongText
                                  ? "pre-wrap"
                                  : "normal",
                              }}
                            >
                              {cell.isDanger ? (
                                <span style={{ fontWeight: 600, color: "red" }}>
                                  {cell.value ?? "-"}
                                </span>
                              ) : (
                                cell.value ?? "-"
                              )}
                            </td>
                          </React.Fragment>
                        ))}
                      </tr>
                    ))}
                </tbody>
              </Table>
              <div className="d-flex gap-2 flex-wrap mt-3">
                {IncidentDetails?.incidentPhotos?.map((doc) => (
                  <div>{renderPhotos(doc)}</div>
                ))}
              </div>
            </div>
          </div>
        </Col>

        {IncidentDetails?.incidentPhotos?.length > 0 &&
        !LeadsDataHalf?.status_list?.includes("Claim Accepted") &&
        !LeadsDataHalf?.status_list?.includes("Claim Declined") ? (
          <Col md={12} lg={12}>
            <div
              style={{
                borderRadius: 10,
                padding: 24,
                boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                marginBottom: 24,
                backgroundColor: "white",
                border: "1px solid #f0f0f0",
              }}
            >
              <h6 style={{ fontWeight: 600, margin: 0 }}> TAKE ACTION</h6>
              <Typography variant="body2" className="text-muted mt-1">
                After reviewing the incident details and photos, please record
                your remarks and submit your decision for this claim.
              </Typography>

              <div className="mt-3 mb-3">
                <TextField
                  label="Add your remarks"
                  placeholder="Write your observations here..."
                  multiline
                  fullWidth
                  minRows={3}
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  sx={{
                    mb: 3,
                    "& .MuiOutlinedInput-root": { borderRadius: 2 },
                  }}
                />
                <div className="text-center">
                  <Button
                    id="AddLeads"
                    className="buttonGreenDefaultColor"
                    size="lg"
                    onClick={() => submitClaim("Claim Accepted")}
                  >
                    Accept{" "}
                    {claimType === "Claim Accepted" && claimRequestLoading && (
                      <Spinner size="sm" />
                    )}
                  </Button>
                  <Button
                    color="danger"
                    size="lg"
                    className="mx-2"
                    onClick={() => submitClaim("Claim Declined")}
                  >
                    Decline
                    {claimType === "Claim Declined" && claimRequestLoading && (
                      <Spinner size="sm" />
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        ) : (
          ""
        )}
      </Row>
      {LeadsDataHalf?.status_list?.includes("Claim Accepted") &&
        !LeadsDataHalf?.status_list?.includes("Claim Declined") && (
          <Row>
            {(hasKycDocs || hasBankDocs) && (
              <Col lg={12} md={12}>
                <div
                  style={{
                    borderRadius: 10,
                    padding: 24,
                    boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                    backgroundColor: "white",
                    border: "1px solid #f0f0f0",
                  }}
                >
                  <h6 style={{ fontWeight: 600, margin: 0 }}>
                    KYC & BANK DOCUMENTS
                  </h6>

                  <div className="d-flex gap-2 flex-wrap mt-3">
                    {documents?.data?.flatMap((category) =>
                      category?.document_category?.toLowerCase() ===
                      "kyc documents"
                        ? category?.document_types?.flatMap((docType) =>
                            docType?.documents?.map((doc) => (
                              <div key={doc.id}>{renderPhotos(doc)}</div>
                            ))
                          )
                        : []
                    )}
                    {documents?.data?.flatMap((category) =>
                      category?.document_category?.toLowerCase() ===
                      "bank documents"
                        ? category?.document_types?.flatMap((docType) =>
                            docType?.documents
                              ?.filter(
                                (doc) =>
                                  doc.entity_id?.toLowerCase() ===
                                  cattleEntityId?.toLowerCase()
                              )
                              ?.map((doc) => (
                                <div key={doc.id}>{renderPhotos(doc)}</div>
                              ))
                          )
                        : []
                    )}
                  </div>
                </div>
              </Col>
            )}
            {/* {hasBankDocs && (
    <Col lg={hasKycDocs ? 6 : 12} md={12}>
      <div
        style={{
                borderRadius: 10,
                padding: 24,
                boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                backgroundColor: "white",
                border: "1px solid #f0f0f0",
              }}
      >
        <h6
          style={{ fontWeight: 600, margin: 0 }}
        >
          BANK DOCUMENTS
        </h6>

        <div className="d-flex gap-2 flex-wrap mt-3">
          {documents?.data?.flatMap((category) =>
            category?.document_category?.toLowerCase() === "bank documents"
              ? category?.document_types?.flatMap((docType) =>
                  docType?.documents
                    ?.filter(
                      (doc) =>
                        doc.entity_id?.toLowerCase() ===
                        cattleEntityId?.toLowerCase()
                    )
                    ?.map((doc) => (
                      <div key={doc.id}>{renderPhotos(doc)}</div>
                    ))
                )
              : []
          )}
        </div>
      </div>
    </Col>
  )} */}
          </Row>
        )}
      {LeadsDataHalf?.status_list?.includes("Claim Accepted") &&
        !LeadsDataHalf?.status_list?.includes("Claim Declined") &&
        hasOtherDocsExceptIncident && (
          <Col md={12} lg={12}>
            <div
              style={{
                borderRadius: 10,
                padding: 24,
                boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                marginBottom: 24,
                backgroundColor: "white",
                border: "1px solid #f0f0f0",
              }}
              className="mt-4"
            >
              <h6 style={{ fontWeight: 600, margin: 0 }}>CATTLE DOCUMENTS</h6>

              <div className="mb-1">
                <div className="d-flex gap-2 flex-wrap mt-3">
                  {Object.keys(IncidentDetails)
                    .filter(
                      (key) =>
                        key !== "incidentPhotos" && key !== "otherDocuments"
                    )
                    .map((key) =>
                      IncidentDetails[key]?.map((doc) => (
                        <div>{renderPhotos(doc)}</div>
                      ))
                    )}
                </div>
              </div>
            </div>
          </Col>
        )}
      {LeadsDataHalf?.status_list?.includes("Claim Accepted") &&
        !LeadsDataHalf?.status_list?.includes("Claim Declined") &&
        hasOtherDocuments && (
          <Col md={12} lg={12}>
            <div
              style={{
                borderRadius: 10,
                padding: 24,
                boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                marginBottom: 24,
                backgroundColor: "white",
                border: "1px solid #f0f0f0",
              }}
              className="mt-4"
            >
              <h6 style={{ fontWeight: 600, margin: 0 }}>OTHER DOCUMENTS</h6>

              <div className="mt-3 mb-1">
                <div className="d-flex gap-2 flex-wrap mt-3">
                  {Object.keys(IncidentDetails)
                    .filter((key) => key === "otherDocuments")
                    .map((key) =>
                      IncidentDetails[key]?.map((doc) => (
                        <div>{renderPhotos(doc)}</div>
                      ))
                    )}
                </div>
              </div>
            </div>
          </Col>
        )}

      {hasAnyDocument &&
        LeadsDataHalf?.status_list?.includes("Claim Accepted") &&
        // LeadsDataHalf?.status_list.includes("Claim Declined")
        !LeadsDataHalf?.status_list?.includes("Claim Approved") &&
        !LeadsDataHalf?.status_list?.includes("Claim Rejected") && (
          <Col md={12} lg={12}>
            <div
              style={{
                borderRadius: 10,
                padding: 24,
                boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                marginBottom: 24,
                backgroundColor: "white",
                border: "1px solid #f0f0f0",
              }}
            >
              <h6 style={{ fontWeight: 600, margin: 0 }}>TAKE ACTION</h6>
              <Typography variant="body2" className="text-muted mt-1">
                After reviewing the documents , please record your remarks and
                submit your decision for this claim.
              </Typography>

              <div className="mt-3 mb-3">
                <TextField
                  label="Add your remarks"
                  placeholder="Write your observations here..."
                  multiline
                  fullWidth
                  minRows={3}
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  sx={{
                    mb: 3,
                    "& .MuiOutlinedInput-root": { borderRadius: 2 },
                  }}
                />
                <div className="text-center">
                  <Button
                    id="AddLeads"
                    className="buttonGreenDefaultColor"
                    size="lg"
                    onClick={() => submitClaim("Claim Approved")}
                  >
                    Approve
                    {claimType === "Claim Approved" && claimRequestLoading && (
                      <Spinner size="sm" />
                    )}
                  </Button>
                  <Button
                    color="danger"
                    size="lg"
                    className="mx-2"
                    onClick={() => submitClaim("Claim Rejected")}
                  >
                    Reject
                    {claimType === "Claim Rejected" && claimRequestLoading && (
                      <Spinner size="sm" />
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        )}
      {LeadsDataHalf?.status_list?.includes("Claim Approved") && (
        // <>
        //   {documents?.data?.some(
        //     (category) =>
        //       category?.document_category?.toLowerCase() ===
        //         "cattle claim payment documents" &&
        //       category?.document_types?.some((docType) =>
        //         docType?.documents?.some(
        //           (doc) => doc.entity_id === LeadsDataHalf.id
        //         )
        //       )
        //   ) ? (
        //     <div
        //       className=""
        //       style={{
        //         borderRadius: "10px",
        //         padding: "24px",
        //         boxShadow: "0 4px 16px rgba(0, 0, 0, 0.06)",
        //         marginBottom: "24px",
        //         backgroundColor: "white",
        //         border: "1px solid #f0f0f0",
        //       }}
        //     >
        //       <h6 style={{ fontWeight: 600, margin: 0 }}>PAYMENT DETAILS</h6>

        //       {documents?.data?.some(
        //         (category) =>
        //           category?.document_category?.toLowerCase() ===
        //             "cattle claim payment documents" &&
        //           category?.document_types?.some((docType) =>
        //             docType?.documents?.some(
        //               (doc) => doc.entity_id === LeadsDataHalf.id
        //             )
        //           )
        //       ) && (
        //         <div className="row align-items-center mb-3 mt-3">
        //           <div className="col-4">
        //             <label className="form-label">Amount</label>
        //             <input
        //               type="text"
        //               className="form-control"
        //               value={
        //                 LeadsDataHalf?.lead_details?.[0]?.service_details
        //                   ?.payment_details?.amount || ""
        //               }
        //               disabled
        //             />
        //           </div>

        //           <div className="col-4">
        //             <label className="form-label">Payment ID</label>
        //             <input
        //               type="text"
        //               className="form-control"
        //               value={
        //                 LeadsDataHalf?.lead_details?.[0]?.service_details
        //                   ?.payment_details?.payment_id || ""
        //               }
        //               disabled
        //             />
        //           </div>

        //           <div className="col-4">
        //             <label className="form-label">Remark</label>
        //             <input
        //               type="text"
        //               className="form-control"
        //               value={
        //                 LeadsDataHalf?.lead_details?.[0]?.service_details
        //                   ?.payment_details?.remark || ""
        //               }
        //               disabled
        //             />
        //           </div>
        //         </div>
        //       )}
        //       <div className="d-flex gap-2 flex-wrap">
        //         {documents?.data?.flatMap((category) =>
        //           category?.document_category?.toLowerCase() ===
        //           "cattle claim payment documents"
        //             ? category?.document_types?.flatMap((docType) =>
        //                 docType?.documents
        //                   ?.filter((doc) => doc.entity_id === LeadsDataHalf.id)
        //                   ?.map((doc) => <div>{renderPhotos(doc)}</div>)
        //               )
        //             : []
        //         )}
        //       </div>
        //     </div>
        //   ) : (
        //     <div>
        //       <div
        //         className="mb-3"
        //         style={{
        //           borderRadius: "10px",
        //           padding: "24px",
        //           boxShadow: "0 4px 16px rgba(0, 0, 0, 0.06)",
        //           marginBottom: "24px",
        //           backgroundColor: "white",
        //           border: "1px solid #f0f0f0",
        //         }}
        //       >
        //         <h6 style={{ fontWeight: 600, margin: 0 }}>PAYMENT DETAILS</h6>
        //         <div className="row mt-4">
        //           <div className="col-4">
        //             <label className="form-label">Payment ID</label>
        //             <input
        //               type="text"
        //               className="form-control"
        //               value={paymentDetails.paymentId}
        //               onChange={(e) =>
        //                 handlePaymentChange("paymentId", e.target.value)
        //               }
        //             />
        //           </div>
        //           <div className="col-4">
        //             <label className="form-label">Amount</label>
        //             <input
        //               type="text"
        //               className="form-control"
        //               value={paymentDetails.amount}
        //               onChange={(e) =>
        //                 handlePaymentChange("amount", e.target.value)
        //               }
        //             />
        //           </div>

        //           <div className="col-4">
        //             <label className="form-label">Remark</label>
        //             <input
        //               type="text"
        //               className="form-control"
        //               value={paymentDetails.remark}
        //               onChange={(e) =>
        //                 handlePaymentChange("remark", e.target.value)
        //               }
        //             />
        //           </div>
        //         </div>
        //         <div className="row g-3 align-items-end mt-2">
        //           <div className="col-md-6">
        //             <label className="form-label fw-semibold">
        //               Payment Receipt
        //             </label>
        //             <input
        //               type="file"
        //               className="form-control"
        //               accept=".pdf,.jpg,.jpeg,.png"
        //               onChange={(e) => handlePaymentFile(e.target.files[0])}
        //             />
        //           </div>

        //           <div className="col-md-3 d-flex justify-content-end">
        //             <Button
        //               className="buttonOrangeDefaultColor2"
        //               disabled={
        //                 !paymentDetails.receiptFile || !paymentDetails.amount
        //               }
        //               onClick={handlePaymentSubmit}
        //             >
        //               {paymentUploading ? (
        //                 <>
        //                   Submitting... &nbsp; <Spinner size="sm" />
        //                 </>
        //               ) : (
        //                 "Upload"
        //               )}
        //             </Button>
        //           </div>
        //         </div>
        //       </div>
        //     </div>
        //   )}
        // </>
         <>
        {PaymentSettlement?.length > 0 ? (
  <div
    style={{
      borderRadius: "10px",
      padding: "24px",
      boxShadow: "0 4px 16px rgba(0, 0, 0, 0.06)",
      marginBottom: "24px",
      backgroundColor: "white",
      border: "1px solid #f0f0f0",
    }}
  >
    <h6 style={{ fontWeight: 600, margin: 0 }}>PAYMENT DETAILS</h6>

    <div className="row align-items-center mb-3 mt-3">
      <div className="col-4">
        <label className="form-label">Amount</label>
        <input
          type="text"
          className="form-control"
          value={
            LeadsDataHalf?.lead_details?.[0]?.service_details
              ?.payment_details?.amount || ""
          }
          disabled
        />
      </div>

      <div className="col-4">
        <label className="form-label">Payment ID</label>
        <input
          type="text"
          className="form-control"
          value={
            LeadsDataHalf?.lead_details?.[0]?.service_details
              ?.payment_details?.payment_id || ""
          }
          disabled
        />
      </div>

      <div className="col-4">
        <label className="form-label">Remark</label>
        <input
          type="text"
          className="form-control"
          value={
            LeadsDataHalf?.lead_details?.[0]?.service_details
              ?.payment_details?.remark || ""
          }
          disabled
        />
      </div>
    </div>

    <div className="d-flex gap-2 flex-wrap mt-3">
      {PaymentSettlement?.map((doc) => (
        <div key={doc.id}>
          {renderPhotos(doc)}
        </div>
      ))}
    </div>
  </div>
) : (
  <div
    style={{
      borderRadius: "10px",
      padding: "24px",
      boxShadow: "0 4px 16px rgba(0, 0, 0, 0.06)",
      marginBottom: "24px",
      backgroundColor: "white",
      border: "1px solid #f0f0f0",
    }}
  >
    <h6 style={{ fontWeight: 600, margin: 0 }}>PAYMENT DETAILS</h6>

    <div className="row mt-4">
      <div className="col-4">
        <label className="form-label">Payment ID</label>
        <input
          type="text"
          className="form-control"
          value={paymentDetails.paymentId}
          onChange={(e) =>
            handlePaymentChange("paymentId", e.target.value)
          }
        />
      </div>

      <div className="col-4">
        <label className="form-label">Amount</label>
        <input
          type="text"
          className="form-control"
          value={paymentDetails.amount}
          onChange={(e) =>
            handlePaymentChange("amount", e.target.value)
          }
        />
      </div>

      <div className="col-4">
        <label className="form-label">Remark</label>
        <input
          type="text"
          className="form-control"
          value={paymentDetails.remark}
          onChange={(e) =>
            handlePaymentChange("remark", e.target.value)
          }
        />
      </div>
    </div>

    <div className="row g-3 align-items-end mt-2">
      <div className="col-md-6">
        <label className="form-label fw-semibold">
          Payment Receipt
        </label>
        <input
          type="file"
          className="form-control"
          accept=".pdf,.jpg,.jpeg,.png"
          onChange={(e) => handlePaymentFile(e.target.files[0])}
        />
      </div>

      <div className="col-md-3 d-flex justify-content-end">
        <Button
          className="buttonOrangeDefaultColor2"
          disabled={
            !paymentDetails.receiptFile || !paymentDetails.amount
          }
          onClick={handlePaymentSubmit}
        >
          {paymentUploading ? (
            <>
              Submitting... <Spinner size="sm" />
            </>
          ) : (
            "Upload"
          )}
        </Button>
      </div>
    </div>
  </div>
)}

        </>
      )}

      {openLightbox && mediaType === "image" && (
        <Lightbox
          image={lightBoxViewImage}
          title="Image Preview"
          onClose={() => {
            setOpenLightBox(false);
          }}
        />
      )}

      {overlayOpen && mediaType === "mp4" && (
        <div
          className="media-overlay d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.7)",
            zIndex: 2000,
            padding: 20,
          }}
        >
          <div
            style={{
              position: "relative",
              width: "95%",
              maxWidth: 1300,
              height: "90vh",
              background: "#fff",
              borderRadius: 8,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px 12px",
                borderBottom: "1px solid #eee",
              }}
            >
              <div style={{ fontWeight: 600 }}>Video Preview</div>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <Button
                  size="sm"
                  color="danger"
                  onClick={() => {
                    setOverlayOpen(false);
                  }}
                >
                  Close
                </Button>
              </div>
            </div>
            <div style={{ flex: 1, minHeight: 0 }}>
              <video
                src={overlayUrl}
                controls
                autoPlay
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  background: "#000",
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
